import { z } from "zod";

export const userInfoSchema = z.object({
  firstName: z.string().trim().min(1),
  lastName: z.string().trim().min(1),
  email: z.string().trim().min(1).email(),
  companyName: z.string().trim().min(1),
  refererId: z.string().optional(),
});

export type UserInfo = z.infer<typeof userInfoSchema>;
